import { render, staticRenderFns } from "./PillsLayout.vue?vue&type=template&id=9f95b8ba&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f95b8ba')) {
      api.createRecord('9f95b8ba', component.options)
    } else {
      api.reload('9f95b8ba', component.options)
    }
    module.hot.accept("./PillsLayout.vue?vue&type=template&id=9f95b8ba&", function () {
      api.rerender('9f95b8ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tabs/PillsLayout.vue"
export default component.exports